import { render, staticRenderFns } from "./taskCenter.vue?vue&type=template&id=76068b1e&scoped=true"
import script from "./taskCenter.vue?vue&type=script&lang=js"
export * from "./taskCenter.vue?vue&type=script&lang=js"
import style0 from "./taskCenter.vue?vue&type=style&index=0&id=76068b1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76068b1e",
  null
  
)

export default component.exports